/**
 * Vincent B943 (Eric 2026-02-14 SPEC STRICK PROD) — Badge de correction
 * factuelle inline dans les transcriptions.
 *
 * Affiche un encadré compact ambre en dessous du texte du segment
 * concerné quand `seg.web_corrections` est présent. Chaque entrée
 * indique : erreur détectée → correction appliquée + source de
 * validation + timestamp.
 */
import { Warning } from "@phosphor-icons/react";

export default function WebCorrectionBadge({ corrections, lang = "fr" }) {
  if (!Array.isArray(corrections) || corrections.length === 0) return null;
  return (
    <div
      className="mt-1 space-y-1"
      data-testid="web-correction-badge"
      data-correction-count={corrections.length}
    >
      {corrections.map((c, i) => (
        <div
          key={i}
          className="text-[10px] bg-amber-50 border border-amber-300 rounded px-2 py-1 flex gap-1.5 items-start"
          data-testid="web-correction-item"
        >
          <Warning size={12} className="text-amber-700 flex-shrink-0 mt-0.5" weight="bold" />
          <div className="flex-1 min-w-0 space-y-0.5">
            <p className="text-amber-900 font-semibold">
              {lang === "fr" ? "Correction factuelle" : "Factual correction"}
              {c.issue ? ` — ${c.issue}` : ""}
            </p>
            <p className="text-zinc-700">
              <span className="line-through text-red-700">« {c.original }»</span>
              <span className="mx-1">→</span>
              <span className="text-emerald-800 font-semibold">« {c.corrected} »</span>
            </p>
            {c.source && (
              <p className="text-zinc-500">
                {lang === "fr" ? "Source : " : "Source: "}
                {c.source}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
